import React, { useState } from 'react';
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';

const moskalenkiPoint = {
  coords: [54.934557, 71.939846] as [number, number],
  name: 'ПРОТЕКО - Москаленки',
  description: 'Омская область, Москаленский муниципальный район, г. п. Москаленское, рп. Москаленки',
  address: 'ул. Железнодорожная, д. 11',
};

const SimpleMap: React.FC = () => {
  const [isBalloonOpen, setIsBalloonOpen] = useState(false);

  return (
    <div className="w-full h-full relative">
      <YMaps>
        <Map
          defaultState={{
            center: moskalenkiPoint.coords,
            zoom: 14
          }}
          width="100%"
          height="100%"
        >
          <Placemark
            geometry={moskalenkiPoint.coords}
            options={{
              preset: 'islands#redDotIcon',
              iconColor: '#F86049'
            }}
            onClick={() => setIsBalloonOpen(true)}
          />
        </Map>
      </YMaps>

      {isBalloonOpen && (
        <div className="absolute top-4 right-4 bg-white rounded-lg shadow-xl border border-gray-200 p-4 min-w-72 max-w-sm z-20">
          <div className="flex justify-between items-start mb-3">
            <h3 className="font-semibold text-gray-800 text-lg">
              {moskalenkiPoint.name}
            </h3>
            <button
              onClick={() => setIsBalloonOpen(false)}
              className="text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="Закрыть"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="space-y-2 text-sm text-gray-600">
            <div>
              <strong>Адрес:</strong> {moskalenkiPoint.description}, {moskalenkiPoint.address}
            </div>
          </div>

          <div className="mt-4 pt-3 border-t border-gray-200">
            <button
              onClick={() => setIsBalloonOpen(false)}
              className="w-full px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors text-sm font-medium"
            >
              Закрыть
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SimpleMap;
